import { render, staticRenderFns } from "./BuyerBudgetAmountReports.vue?vue&type=template&id=4a2b4638&scoped=true"
import script from "./BuyerBudgetAmountReports.vue?vue&type=script&lang=js"
export * from "./BuyerBudgetAmountReports.vue?vue&type=script&lang=js"
import style0 from "./BuyerBudgetAmountReports.vue?vue&type=style&index=0&id=4a2b4638&prod&scoped=true&lang=css"
import style1 from "./BuyerBudgetAmountReports.vue?vue&type=style&index=1&id=4a2b4638&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2b4638",
  null
  
)

export default component.exports